import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPersonAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={12}
    fill="none"
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fill="#999"
      d="M12.75 5.25h-1a.73.73 0 0 1-.534-.214.72.72 0 0 1-.216-.532q0-.316.216-.535a.72.72 0 0 1 .534-.219h1v-1q0-.318.214-.534A.72.72 0 0 1 13.496 2q.316 0 .535.216a.72.72 0 0 1 .219.534v1h1q.319 0 .534.214a.72.72 0 0 1 .216.532q0 .316-.216.535a.72.72 0 0 1-.534.219h-1v1q0 .319-.214.534a.72.72 0 0 1-.532.216.73.73 0 0 1-.535-.216.72.72 0 0 1-.219-.534zM6 6a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 3q0-1.25.875-2.125A2.9 2.9 0 0 1 6 0q1.25 0 2.125.875T9 3t-.875 2.125A2.9 2.9 0 0 1 6 6m-6 4.5v-.417q0-.537.26-.987.261-.45.72-.721 1.145-.667 2.416-1.02A9.7 9.7 0 0 1 6 7q1.334 0 2.604.354t2.417 1.021q.458.27.719.721t.26.987v.417q0 .619-.44 1.06-.442.44-1.06.44H1.493q-.62 0-1.056-.44A1.45 1.45 0 0 1 0 10.5m1.5 0h9v-.417a.49.49 0 0 0-.23-.416 9 9 0 0 0-2.062-.865A8.2 8.2 0 0 0 6 8.5q-1.125 0-2.208.302t-2.063.865a.485.485 0 0 0-.23.417zm4.504-6q.621 0 1.059-.442T7.5 2.996t-.442-1.058A1.46 1.46 0 0 0 5.996 1.5q-.621 0-1.059.442A1.46 1.46 0 0 0 4.5 3.004q0 .621.442 1.059t1.062.437"
    />
  </svg>
);
export default SvgPersonAdd;
